import { useMovementDetailsQuery } from '@shared/generated/graphql';
import { movementDetailsFromFragment } from '@shared/graphql/fromFragments/movement';
import { MovementDetails } from '@shared/types/movement';

type UseMovementDetailsOptions = {
  id: string;
  pollInterval?: number;
  skip?: boolean;
};

type UseMovementDetailsState = {
  movementDetails?: MovementDetails;
  isLoading: boolean;
};

const useMovementDetails = (
  props: UseMovementDetailsOptions
): UseMovementDetailsState => {
  const { id, pollInterval, skip } = props;
  const { data, loading } = useMovementDetailsQuery({
    variables: { id },
    pollInterval,
    skip,
    errorPolicy: 'all',
  });

  const movementDetails = data?.movementById
    ? movementDetailsFromFragment(data.movementById)
    : undefined;

  return { movementDetails, isLoading: loading };
};

export default useMovementDetails;
